export enum Types {
  RETRY = "retry",
  CANCEL = "cancel"
}